// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__pA8mh","ant-table-body":"Table_ant-table-body__PjFyG","ant-table-cell-fix-right":"Table_ant-table-cell-fix-right__eF+DN"};